(ns app.front.view.form.list
  (:require [app.domain.form.model :as form-model]
            [app.front.entities :as entities]
            [app.front.form.render :as fr]
            [app.front.form.subs :as form-subs]
            [app.front.util :refer [for-frag]]
            [app.front.view.form :as form]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(when ^boolean js/goog.DEBUG
  (rf/reg-event-fx ::fill-forms-with-dummy-data
    (fn [_ [_ parent-id]]
      {:comm/dev-command {:command    :application/fill-forms
                          :data       {:id parent-id}
                          :on-success [::entities/merge-entity-db]}})))


(defn- form-tile [lang tr workspace form]
  (let [form-id      (:db/id form)
        status-color (case (<sub [::form-subs/form-status-color-code form-id])
                       :attention "var(--status-attention)"
                       :warning "var(--status-warning)"
                       :success "var(--status-success)"
                       "var(--status-neutral-01)")]
    [:li
     [:a.flex.flex-row.items-start.leading-none
      {:data-cy "application-form-tile"
       :class   (str "flex bg-ui-white rounded border border-solid border-ui-dark-gray mb-2 "
                     "hover:bg-ui-blue-10 focus:bg-ui-violet-20 no-underline p-4 pl-3 text-ui-night-sky-100")
       :style   {:border-left-width "6px"
                 :border-left-color status-color}
       :href    (href/href :view/form {:workspace-id (-> workspace :workspace/id)
                                       :form-id      form-id})}
      [:div.flex.flex-col.pr-4.justify-start
       (cc/icon {:icon        i/arrow-right
                 :description ""
                 :aria-hidden true
                 :width       "12"})]
      [:div.flex.flex-row.flex-1.justify-start.flex-wrap.gap-2.items-start
       [:div.flex.flex-col.flex-1.justify-start
        {:style {:min-width "min(100%, 50em)"}}
        [:div.font-bold {:data-cy "party-name" :class "py-0.5"}
         [form-model/form-label form lang]]
        [:div
         (when-some [change (:latest-change form)]
           [:span.latest-change
            (tr [:last-change-by]
                [((<sub [::date-util/date-time-fn]) (:ts change)) (:user change)])])]]
       [fr/form-status tr form]]]]))


(defn- form-tile-list [lang tr workspace header forms]
  [:div.application-form-list
   [:div.font-bold.py-2.my-2.border-b.border-solid.border-ui-dark-gray
    [:span
     header]]
   [:ul
    (for-frag [[form missing-mandatory-fields?] forms]
      [form-tile lang tr workspace form missing-mandatory-fields?])]])

(defn inline-forms [{:keys [parent]}]
  [:div
   (for-frag [{form-id :db/id} (<sub [::form-subs/application-forms parent])]
     [form/inline-form (util/mmap form-id)])])

(defn forms [{:keys [lang tr workspace loading? parent]}]
  (if (<sub [::form-subs/forms-inline? parent])
    [inline-forms (util/mmap parent)]
    (let [forms-application-data     (<sub [::form-subs/application-data-forms parent])
          forms-waiting-for-customer (<sub [::form-subs/waiting-for-customer-forms parent])
          ce-type?                   (= (:workspace/permit-type workspace) :permit-type/CE)]
      (if loading?
        [cc/structured-list-skeleton]
        [:div
         [:div.application-forms.flex.flex-1
          {:data-cy "application-forms"
           :key     "application-forms"}
          (when-not (empty? forms-waiting-for-customer)
            (form-tile-list lang tr workspace (tr [:waiting-for-customer]) forms-waiting-for-customer))
          (when-not (empty? forms-application-data)
            (form-tile-list lang tr workspace (tr [(if ce-type? :case-data :application-data)])
                            forms-application-data))]
         (when ^boolean js/goog.DEBUG
           [:div.mt-4.controls
            (cc/button {:kind             :secondary
                        :icon             i/heart
                        :icon-position    :right
                        :icon-description (tr [:fill-required-fields])
                        :class-name       "debug-button"
                        :on-click         #(>evt [::fill-forms-with-dummy-data (:db/id parent)])}
                       (tr [:fill-required-fields]))])]))))
